import { render, staticRenderFns } from "./goMiniprogram.vue?vue&type=template&id=18f13841&scoped=true&"
import script from "./goMiniprogram.vue?vue&type=script&lang=js&"
export * from "./goMiniprogram.vue?vue&type=script&lang=js&"
import style0 from "./goMiniprogram.vue?vue&type=style&index=0&id=18f13841&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f13841",
  null
  
)

export default component.exports